import { Skeleton } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import * as React from "react";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export default function CategorySkeleton({ child }: any) {
  return (
    <Grid
      container
      xs={12}
      spacing={4}
      style={{
        backgroundColor: `${child ? "#fff" : "#F5F5F5"}`,
        marginTop: "18px",
        alignItems: "center",
        justifyContent: `${child ? "null" : "center"}`,
      }}
    >
      {[...Array(3)].map((item) => (
        <div style={{ padding: "10px" }}>
          <Skeleton variant="circular" height="15em" width="15em" />
          <br />
          <Skeleton height="2em" width="15em" />
        </div>
      ))}
    </Grid>
  );
}
